import { OTPInput, REGEXP_ONLY_DIGITS, SlotProps } from 'input-otp';
import React, { FC } from 'react';
import { ChangeHandler } from 'react-hook-form';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';

import aligned from '@ui/styled/Aligned';

import theme from '@theme/FolxTheme';

import FlexRow from '../FlexRow';

interface ISlotProps extends SlotProps {
	error?: string;
}

interface ICodeInputProps {
	maxLength: number;
	error?: string;
	ref: React.Ref<any>;
	name: string;
	onChange: (...args: any[]) => unknown;
	onComplete: (...args: any[]) => unknown;
	value?: string;
	onBlur: ChangeHandler;
}

interface ISlotContainerProps {
	error?: string;
	isActive: boolean;
	char?: string | null;
}

const AlignedRow = styled(aligned(FlexRow))`
	text-align: center;
`;

const SlotContainer = styled.div<ISlotContainerProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 4.8rem;
	height: 5.6rem;
	padding: 1.2rem 0.8rem;
	border-radius: 1.3rem;
	border-width: 0.1rem;
	border-style: solid;
	border-color: ${(props) =>
		props.error
			? theme.colors.darkRed
			: props.isActive || props.char
			? theme.colors.black
			: theme.colors.darkGray};
`;

const OTPInputContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	gap: 1.6rem;

	// Have not been able to style this foolish module w/o doing this...
	.otp-input {
		display: flex;
		flex-direction: row;
		gap: 0.6rem;
		font-family: 'Chalet', sans-serif;
		font-size: 2.4rem;
		font-style: normal;
		font-weight: bold;
	}
`;

const Slot: FC<ISlotProps> = ({ char, placeholderChar, isActive, error }) => (
	<SlotContainer {...{ char, isActive, error }}>
		<div>{char ?? placeholderChar}</div>
	</SlotContainer>
);

const CodeInput: FC<ICodeInputProps> = ({ maxLength, error, value, onChange, onComplete }) => {
	return (
		<OTPInputContainer>
			<OTPInput
				containerClassName="otp-input"
				inputMode="numeric"
				pattern={REGEXP_ONLY_DIGITS}
				maxLength={maxLength}
				value={value}
				onChange={onChange}
				onComplete={onComplete}
				render={({ slots }) => slots.map((slot, idx) => <Slot key={idx} error={error} {...slot} />)}
			/>
			<AlignedRow justifyContent="center">
				<BasicText variant="smallText" color="darkRed">
					{error}
				</BasicText>
			</AlignedRow>
		</OTPInputContainer>
	);
};

export default CodeInput;
